import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, clearAuthToken } from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!localStorage.getItem("reviewqr_token")) {
      setStatus("out");
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        setStatus("in");
      })
      .catch((err) => {
        // Solo un 401 real invalida la sesión. Un error de red o un arranque
        // en frío del servidor NO debe borrar el token guardado.
        if (err.response?.status === 401) clearAuthToken();
        setStatus("out");
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("reviewqr_token", data.token);
    setAuthToken(data.token);
    setUser(data.user);
    setStatus("in");
    return data.user;
  };

  const logout = useCallback(() => {
    clearAuthToken();
    setUser(null);
    setStatus("out");
  }, []);

  const loginWithToken = useCallback((token, userData) => {
    localStorage.setItem("reviewqr_token", token);
    setAuthToken(token);
    setUser(userData);
    setStatus("in");
  }, []);

  return (
    <AuthContext.Provider value={{ user, status, login, logout, loginWithToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
